<template>
  <div :class="{'option': true, 'playModeScale': scaleMode == 'playMode'}" v-if="TokenState && !iframe && userId != ownerId && type != 'pin'">
      <button @click="onPin">
        <div class="icon-box">
          <font-awesome-icon :icon="['fas', 'thumbtack']" class="icon" />
        </div>
        <div class="label-box">
          Pin
        </div>
      </button>
  </div>
</template>

<script>
import axios from 'axios'
import alert from '@/lib/alert'

export default {
  name: 'PinButton',
  props: {
    shortId: String,
    ownerId: String,
    type: String,
    exerciseId: String,
    scaleMode: String
  },
  data() {
    return {
      iframe: false,
      userId: null
    }
  },
  methods: {
    getUserId() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}getUserId`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        }
      }).then(result => {
        this.userId = result.data.userId;
      }).catch(err => {
        console.log(err);
        alert.showError(err);
      })
    },
    onPin() {
      let sourceId = this.exerciseId;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}addPin`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          exerciseId: sourceId,
        }
      }).then(() => {
        console.log('Pin Created');
        alert.showSuccess('Pin Created');
      }).catch(() => {
        console.log('Pin Creating Error');
        alert.showError('Pin Creating Error');
      })
    },
  },
  computed: {
    TokenState() {
      if(localStorage.getItem('token')) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if(window.location !== window.parent.location) {
      this.iframe = true;
    }
    if(localStorage.getItem('token')) {
      this.getUserId();
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  a {
    text-decoration: none;
  }

  button {
    width: auto;
    height: 2.5rem;
    display: flex;
    transition: 0.3s;
    background: none;
    outline: none;
    border: none;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .icon-box {
    width: 2.5rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      color: white;
      font-size: 1.3rem;
    }
  }

  .label-box {
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0.2rem;
    padding-right: 0.5rem;
    color: white;
    font-size: 1.3rem;
    font-weight: bold;

    @media (max-width: 600px) {
      display: none;
    }
  }
}

.playModeScale {
  @media (max-width: 450px) {
    display: none;
  }
  .label-box {
    @media (max-width: 1200px) {
      display: none;
    }
  }
}
</style>